// Login — the mockup's centred card. No role tabs and no demo accounts: the account
// carries the role, and letting the user pick one would either be decoration or a way to
// probe which accounts exist.

import { useState } from 'react';
import * as api from '../api';
import type { Lang, PanelUser } from '../types';
import { Callout, Icon, LangSwitch } from '../ui';

export default function Login({ onLoggedIn, lang, onSetLang }: {
  onLoggedIn: (u: PanelUser) => void;
  lang: Lang;
  onSetLang: (l: Lang) => void;
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      onLoggedIn(await api.login(username.trim(), password));
    } catch (err) {
      setError(err instanceof api.ApiError ? err.message : 'Giriş yapılamadı.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="login-glow" />
      <div className="login-lang"><LangSwitch lang={lang} onSet={onSetLang} /></div>
      <div className="login-card">
        <div className="login-brand">
          <span className="logo-tile"><Icon name="graphic_eq" /></span>
          <div>
            <div className="nm">Ses Kalite QMS</div>
            <div className="sub">Çağrı kalite yönetimi paneli</div>
          </div>
        </div>

        <form className="login-form" onSubmit={submit}>
          <h1>Giriş</h1>
          <p className="fsub">Devam etmek için hesabınıza giriş yapın.</p>

          <label htmlFor="u">Kullanıcı adı</label>
          <input
            id="u" className="inp" autoComplete="username" autoFocus value={username}
            onChange={(e) => setUsername(e.target.value)} placeholder="ad.soyad"
          />

          <label htmlFor="p">Şifre</label>
          <input
            id="p" className="inp" type="password" autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
          />

          {error ? <Callout tone="bad">{error}</Callout> : null}

          <button className="btn pri full" type="submit" disabled={busy || !username || !password}>
            {busy ? 'Giriş yapılıyor…' : 'Giriş yap'}
          </button>
        </form>

        <div className="login-foot">Rol ve yetkileriniz yöneticiniz tarafından atanır.</div>
      </div>
    </div>
  );
}
